import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import * as numberUtils from "util/number";
import { statusTagColor } from "util/thirdPayment";
import InfoTag from "pages/echeck/components/InfoTag";

const PaymentItem = ({ payment, isDesktop, viewTicket }) => {

    const options = [
        {
            text: "payments.menu.ticket",
            textType: "I18N",
            func: () => viewTicket(),
        },
    ];

    const getCodeMsg = (code) => {
        if (code === "FINISHED") {
            return "FINALIZADA";
        }
        if (code === "FAILED") {
            return "FALLIDA";
        }
        return code;
    };

    return (
        <>
            <GridTable.Data columnStart={1} columnWidth={1} rowStart={1} alignX="center">
                {isDesktop ? (
                    <CustomText text={payment.bussinessName} />
                ) : (
                    <CustomData
                        titleText="payments.table.business"
                        titleTextType="I18N"
                        valueText={payment?.bussinessName}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1}
                columnWidth={1} rowStart={isDesktop ? 1 : 2}
                alignX="center">
                {isDesktop ? (
                    <CustomText text={String(payment?.paymentCode).padStart(12,"0")} className="history-payment-item-code"/>
                ) : (
                    <CustomData
                        titleText="payments.table.paymentCode"
                        titleTextType="I18N"
                        valueText={String(payment?.paymentCode).padStart(12,"0")}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 3} alignX="center">
                {isDesktop ? (
                    <FormattedDate date={payment?.paymentDate} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="payments.table.paymentDate"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={payment?.paymentDate} dateFormat="DD/MM/YYYY" />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 4 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 4} alignX="center">
                {isDesktop ? (
                    <FormattedAmount
                        currency="ARS"
                        quantity={numberUtils.formatAmountStrDouble(payment?.totalAmount)}
                        className="data-amount content-data-strong"
                    />
                ) : (
                    <CustomData
                        titleText="payments.table.amount"
                        titleTextType="I18N"
                        valueText={<FormattedAmount
                            currency="ARS"
                            quantity={numberUtils.formatAmountStrDouble(payment?.totalAmount)}
                            className="data-amount content-data-strong"
                        />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 5} alignX="center">
                {isDesktop ? (
                    <InfoTag
                        type="info"
                        message={getCodeMsg(payment?.status)}
                        tagBackground={statusTagColor(payment?.status)}
                    />
                ) : (
                    <CustomData
                        titleText="payments.table.status"
                        titleTextType="I18N"
                        valueText={<InfoTag
                            type="info"
                            message={getCodeMsg(payment?.status)}
                            tagBackground={statusTagColor(payment?.status)}
                        />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 2}
                columnWidth={1}
                rowStart={1}
                alignY="center"
                className="adhered-services-button"
                alignX="center">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
            </GridTable.Data>
        </>
    );
};

PaymentItem.propTypes = {
    receivedAdheredService: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
    payScheduledService: func.isRequired,
};

export default PaymentItem;
